<template>
<div class="detect-page">
  <div class="car-baseinfo">
    <div class="info-items">
      <div class="dt-item">
        <div class="field">里程：</div>
        <div class="value">{{carInfo.trip | format10Thou}}万公里</div>
      </div>
      <div class="dt-item">
        <div class="field">车型：</div>
        <div class="value">{{carInfo.model}}</div>
      </div>
      <div class="dt-item">
        <div class="field">车身颜色：</div>
        <div class="value">{{carInfo.bodyColor}}</div>
      </div>
      <div class="dt-item">
        <div class="field">变速箱：</div>
        <div class="value">{{carInfo.gearbox | gearBoxFormat}}</div>
      </div>
      <div class="dt-item">
        <div class="field">排量：</div>
        <div class="value">{{carInfo.power}}{{carInfo.airIntakeType === 1 ? 'T' : 'L'}}</div>
      </div>
      <div class="dt-item">
        <div class="field">过户次数：</div>
        <div class="value">{{carInfo.transferCnt}}次</div>
      </div>
    </div>
  </div>
  <div class="detect-list">
    <div class="det-item" v-for="(list, title) in paramBody" :key="title">
      <div class="det-title">
        <span class="title">{{title}}</span>
        <div class="right">
            <div class="warn" v-if="warnParam[title] > 0">
              <span>{{warnParam[title]}}项</span>
              <div class="iconfont uc-zhuyi"></div>
            </div>
            <div :class="expandStatus[title] ? 'normal open-ls' : 'normal close-ls'" @click="onSwitchExpand(title)">
              <span>{{list.length}}项</span>
              <div class="iconfont uc-jinru"></div>
            </div>
        </div>
      </div>
      <div class="list" v-show="expandStatus[title]">
            <div class="row" v-for="(item, index) in paramBody[title]" :key="title + index">
              <span class="name">{{item.title}}</span>
              <span class="nom" :style="{color: item.warn ? '#f33' : '#56DE60'}">
                {{convertBodyStatus(item)}}
              </span>
              <!-- <span class="nom" v-else>{{item.value}}</span> -->
            </div>
          <!-- <div class="row">
            <div class="name">左A柱  左前纵梁  变形XB</div>
            <div class="iconfont uc-zhuyi"></div>
          </div> -->
      </div>
    </div>
  </div>
  <div class="remark">
      <div class="iconfont uc-zhuyi"></div>
      <div class="text">基本信息为初评时录入，实际参数以看车时为准！</div>
    </div>
</div>
</template>

<script>
import { mapState } from "vuex";
import { getCarDetectInfo } from '../api'
import { deepClone } from '../utils'
const DetectParams = require('../configs/detectParams.json')
const carBodyStatus = require('../configs/carBodyStatus.json')
const gearTypes = ["手动MT", "自动AT", "双离合DSG", "CVT"]

export default {
  components: {},
  props: {},
  data() {
    return {
      DetectParams,
      warnParam: {},
      expandStatus: {},
      carInfo: {},
      DetectData: {}
    }
  },
  watch: {
    pageInfo(newInfo){
      const Extinfo = newInfo.Extinfo
      console.log('newInfo.Extinfo:', newInfo.Extinfo)
      if(Extinfo){
        this.carInfo = Extinfo
      }
    }
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      'pageInfo',
      "userInfo"
    ]),
    paramBody(){
      let delectParams = deepClone(this.DetectParams)
      delete delectParams["基础信息"]
      delete delectParams["相关人员"]
      console.log(delectParams)
      return delectParams
    }
  },
  filters: {
    gearBoxFormat(type){
      return gearTypes[type]
    },
    format10Thou(price){
          if(price){
             return (price / 10000).toFixed(2) - 0
          }else{
              return ""
          }
    },

  },
  methods: {
    onSwitchExpand(title){
      this.expandStatus[title] = !this.expandStatus[title]
    },
    convertBodyStatus(item){
      const {value, title, group} = item
      if(group === "车身检查"){
        const [status, index] = value.split(',')
        if(status === 'ZC'){
          return '正常'
        }else{
          const item = carBodyStatus.find(st => st.value === status)
          if(item){
            const desc = item.children.find(child => child.value === index)
            return `${item.label} - ${desc.label}`
          }else{
            return ""
          }
        }
      }else{
        return value
      }
    },
    async loadDetectInfo(){
      const { psn } = this.$route.query
      const ret = await getCarDetectInfo(psn)
      if(ret.code === 0 && ret.data){
        const detInfo = ret.data
        let warnCount = {}, expandStatus = {}
        Object.keys(this.DetectParams).forEach((key, index) => {
          let list = this.DetectParams[key] || []
          warnCount[key] = 0
          expandStatus[key] = index === 1
          list.forEach(item => {
              if(item.value !== detInfo[item.key]){
                warnCount[key] ++
                item.warn = true
              }
              if(item.group === '车身检查'){
                item.value = detInfo[item.key] || "ZC"
              }else if(detInfo[item.key] > -1 && item.options.length > 0){
                const _index = detInfo[item.key] - 0
                item.value = item.options[_index] || ""
              }else{
                item.value = detInfo[item.key] || ""
              }
          })
        })
        console.log('DetectParams:',this.DetectParams)
        this.warnParam = warnCount
        this.expandStatus = expandStatus
      }
    }
  },
  beforeCreate() {},
  async created() {
    await this.loadDetectInfo()
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@mixin borderFrame(){
    margin: 0.30407459963511047rem;
    padding: 0.20271639975674033rem;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 0.040543279951348064rem 0.15203729981755523rem 0px rgba(0, 0, 0, 0.06);
}
.detect-page{
    .car-baseinfo{
        @include borderFrame();
        .info-items{
            display: flex;
            flex-direction:row;
            flex-wrap: wrap;
            .dt-item{
                width: 50%;
                font-size: 0.2635313196837624rem;
                display: flex;
                padding: 0.10135819987837016rem 0px;
                .field{
                    color:#888;
                }
                .value{
                    color:#565656;
                }
            }
        }
    }
    .detect-list{
        @include borderFrame();
        display: flex;
        flex-direction: column;
        .det-item{
            border-bottom: solid 1px #f4f4f4;
            .det-title{
                display: flex;
                justify-content: space-between;
                font-size: 0.2635313196837624rem;
                align-items: center;
                padding: 0.20271639975674033rem 0px;
                .title{
                    color:#565656;
                }
                .right{
                    color: #888;
                    display: flex;
                    align-items: center;
                    .warn{
                        display: flex;
                        align-items: center;
                        .uc-zhuyi{
                            margin-left: 0.10135819987837016rem;
                            color: #E84275;
                            font-size: 0.34461787958645856rem;
                        }
                    }
                    .normal{
                        display: flex;
                        align-items: center;
                        padding-left: 0.15203729981755523rem;
                        .uc-jinru{
                            color:#888;
                            margin-left: 0.10135819987837016rem;
                            font-size: 0.34461787958645856rem;
                            //transform: rotate(90deg);
                        }
                    }
                    .open-ls{
                      .uc-jinru{
                        transform:rotate(270deg);
                        transition:transform .13s linear;
                      }
                    }
                    .close-ls{
                      .uc-jinru{
                        transform:rotate(90deg);
                        transition:transform .13s linear;
                      }
                    }            
                }
            }
            .list{
                background:#F3F6F8;
                border-radius: 5px;
                padding: 10px;
                margin-bottom: 0.2533954996959254rem;
                .row{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0.10135819987837016rem;
                    font-size: 0.2635313196837624rem;
                    .name{
                        max-width: 70%;
                        color:#888888;
                    }
                    .nom{
                        color:#56DE60;
                    }
                    .uc-zhuyi{
                        font-size: 0.34461787958645856rem;
                        color: #E84275;
                    }
                }
            }
        }
    }
    .remark{
        padding: 0px 0.30407459963511047rem 0.30407459963511047rem 0.30407459963511047rem;
        display: flex;
        font-size: 0.22298803973241435rem;
        color:#666;
        align-items: center;
        .uc-zhuyi{
            font-size: 0.28380295965943647rem;
            color:#666;
        }
        .text{
            margin-left: 0.10135819987837016rem;
        }
    }
}
</style>